module.exports = __webpack_public_path__ + "img/list_empty.bd8907f8.png";